/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class GisDatastoreModel {
        public gisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        public currentDatastore: Wars.Domain.Model.Gis.GisDatastore;
        public newGeometryType: Wars.Domain.Model.Codes.Enums.GeometryType;

        constructor(private gisDatastoreService: services.GisDatastoreService,
            private growl: angular.growl.IGrowlService,
            private systemLevelService: services.SystemLevelService) {
            gisDatastoreService.getGisDatastores()
                .then(results => {
                    this.gisDatastores = results;
                });
            this.systemLevelService.getSystemLevel().then(r => {
                this.systemLevel = r;
            });
        }

        public add() {
            this.currentDatastore = this.gisDatastoreService.createGisDatastore();

            this.currentDatastore.systemLevel = this.systemLevel;
            this.currentDatastore.name = "New Gis Datastore";
            this.currentDatastore.maxPerBox = 64;
            this.currentDatastore.isActive = false;

            //this.currentDatastore.quadtree = this.gisDatastoreService.createQuadTree();

            //TODO: Let this be user selected or entered in the future
            //this.currentDatastore.quadtree.boundingBox.yMax = 31.14132;
            //this.currentDatastore.quadtree.boundingBox.xMin = -87.843269;
            //this.currentDatastore.quadtree.boundingBox.yMin=24.520060;
            //this.currentDatastore.quadtree.boundingBox.xMax = -79.246760;
            //this.currentDatastore.quadtree.gisDatastore_id = this.currentDatastore.id;
            //this.currentDatastore.quadtree.childrenCount = 0;
            //this.currentDatastore.quadtree.needsToSubdivide = false;

            this.gisDatastores.push(this.currentDatastore);

            this.gisDatastoreService.saveAllChanges();
        }

        public remove() {
            this.currentDatastore.entityAspect.setDeleted();
            this.gisDatastores.remove(this.currentDatastore);
            this.gisDatastoreService.saveAllChanges();
            this.currentDatastore = null;
        }

        public save() {
            if (!this.currentDatastore.isActive) {
                this.gisDatastoreService.saveAllChanges();
            }
        }

        public activate() {
            this.gisDatastoreService.activate(this.currentDatastore.id).then(r => {
                this.currentDatastore.isActive = true;
            });
        }

        public addGeometryType() {
            if (Enumerable.from(this.currentDatastore.availableDatastoreTypes)
                .any(d => d.geometryType === this.newGeometryType)) {
                this.growl.error("This geometry type has already been added to the gis datastore");
            } else {
                const newGeoType = this.gisDatastoreService.createGeometryDatastoreType();
                newGeoType.gisDatastore = this.currentDatastore;
                newGeoType.geometryType = this.newGeometryType;

                this.currentDatastore.availableDatastoreTypes.push(newGeoType);

                this.gisDatastoreService.saveAllChanges();
            }
        }

        public removeGeometryType(geometryDatastoreType: Wars.Domain.Model.Gis.GeometryDatastoreType) {
            geometryDatastoreType.entityAspect.setDeleted();
            this.gisDatastoreService.saveAllChanges();
        }

        private systemLevel: Wars.Domain.Model.SystemLevel;
    }
}